import React from "react";
import styled from "@emotion/styled";

export const HandleStyled = styled.div`
  position: absolute;
  width: 10px;
  right: -10px;
  cursor: ew-resize;
  top: 0;
  bottom: 0;
  z-index: 1;
  transition: all 0.2s ease;
`;

export const Handle = () => {
  return <HandleStyled />;
};
